import React, { useState } from "react";
import HeaderPanel from "../../components/layout/HeaderPanel";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import FooterPanel from "../../components/layout/FooterPanel";
import { useAppDispatch } from "../../redux/hooks/hooks";
import { navigate } from "../../redux/feature/general/navigation-slice";
import { SETTINGS } from "../../utils/constants/navigation";
import { mergeStyleSets } from "@fluentui/react";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { ButtonVariants } from "../../styles/fluent/ButtonVariants";

const classNames = mergeStyleSets({
  icon: {
    width: "300px",
    height: "200px",
    objectFit: "contain",
  },
  iconWrapper: { margin: "1.5rem auto 0 auto", display: "flex", justifyContent: "center" },
});

const pageContent = [
  {
    title: "CCH® Tagetik Intelligent Disclosure",
    imgSrc: "assets/WK Logo.svg",
    description: "Communicate corporate value with automated narrative reporting and disclosure management",
  },
  {
    title: "Build your financial and sustainability reports",
    imgSrc: "assets/selectReport.svg",
    description: "Ensure data consistency and integrity",
  },
  {
    title: "Collaborate",
    imgSrc: "assets/collaborate.svg",
    description: "Share your documents and start co-editing with your colleagues",
  },
  {
    title: "Use multiple sources",
    imgSrc: "assets/Dimension.svg",
    description: "Ingest data from any internal and external sources",
  },
];

export const WelcomePage: React.FunctionComponent = () => {
  const dispatch = useAppDispatch();
  const [currentPage, setCurrentPage] = useState(0);

  const handleNextClick = () => {
    if (currentPage < pageContent.length - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleBackClick = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const currentPageData = pageContent[currentPage];

  return (
    <>
      <HeaderPanel applyPadding>{formatMessage("cof.access.welcome")}</HeaderPanel>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "70vh",
          textAlign: "center",
        }}
      >
        <div
          style={{ fontWeight: "bold", fontSize: "x-large", color: currentPage === 0 ? "black" : "var(--color-blue)" }}
        >
          {currentPageData.title}
        </div>
        <div className={classNames.iconWrapper}>
          <img src={currentPageData.imgSrc} alt="Page Image" />
        </div>
        <div
          style={{
            fontSize: "1.15rem",
            fontWeight: "500",
            lineHeight: "1.25rem",
            color: "var(--color-blue)",
            padding: currentPage === 1 ? "0rem 1rem 0rem 1rem" : "1rem 1rem 0rem 1rem",
            maxWidth: "600px",
          }}
        >
          {currentPageData.description}
        </div>
      </div>
      <FooterPanel>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {currentPage === 0 ? (
            <PrimaryButton
              className={ButtonVariants.white}
              text={formatMessage("cof.base.skip")}
              onClick={() => dispatch(navigate(SETTINGS))}
            />
          ) : (
            <PrimaryButton
              className={ButtonVariants.white}
              text={formatMessage("cof.base.back")}
              onClick={handleBackClick}
            />
          )}
          <div
            className="k-scrollview-nav-wrap"
            style={{
              display: "flex",
              justifyContent: "center",
              flexGrow: 1,
            }}
          >
            <ul className="k-scrollview-nav" style={{ display: "flex", gap: "10px" }}>
              {[...Array(4)].map((_, index) => (
                <li
                  key={index}
                  className={`k-link ${currentPage === index ? "k-primary" : ""}`}
                  onClick={() => setCurrentPage(index)}
                />
              ))}
            </ul>
          </div>
          {currentPage < 3 ? (
            <PrimaryButton
              text={formatMessage("cof.base.next").toUpperCase()}
              style={{ float: "right" }}
              onClick={handleNextClick}
            />
          ) : (
            <PrimaryButton
              text={formatMessage("cof.base.getstarted").toUpperCase()}
              style={{ float: "right" }}
              onClick={() => dispatch(navigate(SETTINGS))}
            />
          )}
        </div>
      </FooterPanel>
    </>
  );
};
